import React, { useState } from "react";
import SystemActions from "@/store/actions/system";
import { useDispatch } from "react-redux";
import Dropzone from "react-dropzone";
import get from "lodash/get";

const UploadS2 = props => {
    const { children, successCb, isDoc } = props;
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState(null);

    const fileHandler = files => {
        setLoading(true);
        let formData = new FormData();
        files.forEach(file => formData.append("files", file));

        const cb = {
            success: (uploadedImages = {}) => {
                setImage(uploadedImages);
                successCb(uploadedImages);
            },
            failure: e => {
            },
            finally: () => {
                setLoading(false);
            }
        };

        dispatch(SystemActions.UploadFile({ files: formData, cb }));
    };

    return (
        <Dropzone
            onDrop={fileHandler}
            accept={isDoc ? ".doc,.docx,.txt,.pdf " : ""}>
            {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                    {children({
                        image,
                        loading,
                        src: get(image, "thumbnails.small.src")
                    })}
                    <input {...getInputProps()} id={"file"} />
                </div>
            )}
        </Dropzone>
    );
};

export default UploadS2;
